import { ApplicationInstance } from "../../../models/workshop/instance"
import { Agent, AgentType } from "../../../models/agent"

export const transformApplicationToAgent = (application: ApplicationInstance): Agent => ({
    Id: application.Id,
    Type: AgentType.AppstoreAgent,
    ApplicationTitle: application.Title,
    Params: {},
    UpdatedAt: null
})
